<script setup>
import CheckBox from 'v3/components/Form/CheckBox.vue';

const { value, label, description } = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const onChange = (_, newValue) => {
  emit('change', newValue);
};
</script>

<template>
  <div class="flex gap-3 w-full items-start">
    <div class="flex items-center mt-0.5">
      <CheckBox
        id="auto-navigation-checkbox"
        :is-checked="value"
        :value="value"
        @update="onChange"
      />
    </div>
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
  </div>
</template>
